import { Button, ButtonProps } from '@cmpsr/components';

export default function RenewMembershipAction({ onClick }: ButtonProps) {
  return (
    <Button onClick={onClick} size="s" variant="link-primary" justifyContent="flex-start">
      Renew Membership
    </Button>
  );
}
